"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentSplits = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.SegmentSplits = {
    priority: Number.MAX_VALUE,
    label: 'fields.payload.mor_entity_answers.segment_splits.label',
    fallbackLabel: 'Please provide an estimated volume split per segment of your total entity portfolio and their selling countries.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
